module.exports = __webpack_public_path__ + "media/img/frontend_application/celebrate-icon-5e0be637caf8a3565903de6794d341b0.png";